export default __webpack_public_path__ + "static/media/anarb-one-point-5-768x512.8e36bd8e.jpg";